import TrapDetailsPopover from './TrapDetailsPopover'
import enhance from './TrapDetailsPopover.enhancer'

export default enhance(TrapDetailsPopover)



// WEBPACK FOOTER //
// ./src/components/organisms/TrapDetailsPopover/index.js